import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import spacing from 'theme/spacing';
import { pxToRem } from 'theme/utils';
import ErrorNotificationImage from '../../images/ServerDown_illustration 2.png';
import { Paragraph } from '@purpurds/purpur/paragraph';
import { Heading } from '@purpurds/purpur/heading';
import { useMediaQuery } from 'utils/media-query';
import { FRONT_PAGE_PATH } from 'constants/paths';
import { Link } from 'react-router-dom';
import { PurPurButton } from 'components/button';
const TEXT = {
    TO_FRONT_PAGE: 'Gå tilbake til forsiden',
};
const ErrorNotificationContainer = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: ${spacing.spacing32};
  cursor: default;
`;
const ErrorNotificationHeader = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.spacing24};
  text-align: center;
  max-width: ${pxToRem(300)};
`;
const ErrorNotificationContentContainer = styled.div `
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? `column` : 'row')};
  ${({ $isMobile }) => ($isMobile ? 'align-items: center' : '')}
`;
const StyledErrorNotificationImage = styled.img `
  overflow: visible;
  width: ${pxToRem(165)};
  ${({ $isMobile }) => ($isMobile ? `margin-bottom: ${spacing.spacing24}` : '')};
`;
const StyledLink = styled(Link) `
  margin-top: ${spacing.spacing16};
`;
export const ErrorNotification = ({ title, text, link, }) => {
    const isMobile = useMediaQuery({ query: `(max-width: 600px)` });
    return (_jsxs(ErrorNotificationContainer, { children: [isMobile && (_jsx(StyledErrorNotificationImage, { src: ErrorNotificationImage, "$isMobile": isMobile })), _jsxs(ErrorNotificationHeader, { children: [title && (_jsx(Heading, { tag: "h1", variant: "title-200", children: title })), text && _jsx(Paragraph, { children: text }), link && (_jsx(StyledLink, { to: FRONT_PAGE_PATH, children: _jsx(PurPurButton, { variant: 'tertiary-purple', children: TEXT.TO_FRONT_PAGE }) }))] }), _jsx(ErrorNotificationContentContainer, { "$isMobile": isMobile, children: !isMobile && (_jsx(StyledErrorNotificationImage, { src: ErrorNotificationImage, "$isMobile": isMobile })) })] }));
};
